import $http from './http'
import config from './config'

export default {
    name: 'side',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    getFileContent(filetype,filepath){
        return $http.get(this.getUrl(`/Storage/Index/${filetype}?filepath=${filepath}`),{failTips:false});
    },
    getUploadImg(data,id){
        return $http.post(this.getUrl(`/Storage/UploadImg?id=${id}`),data,{failTips:false});
    },
    getValidImageUrl() {
        return `${this.getUrl("/Common/ValidCode")}?${Math.random()}`;
      },
}    


// WEBPACK FOOTER //
// ./src/apis/sideapi.js